import NumberTable, {
  INumberTableProps,
} from "@template/blocks/NumberPickerSection/component/Tables/NumberTable";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import useCurrency from "@/lib/helpers/hooks/useCurrency";

const Tables: any = ({
  table,
  context,
  inPageNavigation,
  numberLimit,
}: {
  table?: { standard?: boolean; memorable?: boolean; nonGeo?: boolean };
  context?: string;
  inPageNavigation?: boolean;
  numberLimit?: number;
}) => {
  const { numberType, countryCode, numberCategory } = useTypedSelector(
    (state) => state.numbers.options
  );
  const isMobile = numberType === "mobile";
  const currency = useCurrency();

  const options = [
    table?.standard && {
      type: "standard",
      label: "Standard",
      showAreaCode: true,
    },
    table?.memorable && {
      type: "premium",
      label: "Memorable",
      showAreaCode: true,
    },
    table?.nonGeo &&
      countryCode === "77" && {
        type: "nonGeo" as const,
        label: "Non-Geographic",
        showAreaCode: false,
      },
  ].filter(Boolean);

  const types: INumberTableProps[] = [
    ...(isMobile
      ? currency === "$"
        ? [
            {
              type: "standard",
              label: "Mobile",
              showAreaCode: true,
            },
          ]
        : [
            {
              type: "premium",
              label: "Mobile",
              showAreaCode: true,
            },
          ]
      : context === "individual"
        ? options
        : numberCategory === "all"
          ? [
              {
                type: "standard",
                label: "Standard",
                showAreaCode: true,
              },
              {
                type: "premium",
                label: "Memorable",
                showAreaCode: true,
              },
            ]
          : numberCategory === "standard"
            ? [
                {
                  type: "standard",
                  label: "Standard",
                  showAreaCode: true,
                },
              ]
            : [
                {
                  type: "premium",
                  label: "Memorable",
                  showAreaCode: true,
                },
              ]),
    ...(countryCode === "77" &&
    numberCategory === "all" &&
    context !== "individual"
      ? [
          {
            type: "nonGeo" as "nonGeo",
            label: "Non-Geographic",
            showAreaCode: false,
          },
        ]
      : []),
  ] as INumberTableProps[];

  return (
    <>
      {types.map((type) => (
        <NumberTable
          id={`number-table-${type.type}`}
          type={type.type}
          key={type.type}
          label={type.label}
          showAreaCode={type.showAreaCode}
          inPageNavigation={inPageNavigation}
          numberLimit={numberLimit}
        />
      ))}
    </>
  );
};

export default Tables;
